import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import './DistrictMap.css';

function DistrictMap({ data }) {
  const chartData = data.slice(0, 8).map(d => ({
    district: d.district.length > 14 ? d.district.slice(0, 14) + '…' : d.district,
    fullName: d.district,
    Projects: d.projects,
    Beneficiaries: d.beneficiaries
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const d = payload[0].payload;
      return (
        <div className="district-tooltip">
          <p className="district-tooltip-title">{d.fullName}</p>
          <p>Projects: <strong>{d.Projects}</strong></p>
          <p>Beneficiaries: <strong>{d.Beneficiaries.toLocaleString()}</strong></p>
        </div>
      );
    }
    return null;
  };

  if (!chartData.length) {
    return <div className="no-data">No district data available</div>;
  }

  return (
    <div className="district-map">
      <ResponsiveContainer width="100%" height={280}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 0, right: 20, left: 90, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} />
          <XAxis type="number" style={{ fontSize: 12 }} />
          <YAxis
            dataKey="district"
            type="category"
            width={85}
            style={{ fontSize: 12 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="Projects" fill="#00205b" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ResponsiveContainer>

      <div className="district-summary">
        <div className="ds-item">
          <span className="ds-label">Total Districts</span>
          <span className="ds-value">{data.length}</span>
        </div>
        <div className="ds-item">
          <span className="ds-label">Top District</span>
          <span className="ds-value">{data[0]?.district || '-'}</span>
        </div>
        <div className="ds-item">
          <span className="ds-label">Most Projects</span>
          <span className="ds-value">{data[0]?.projects || 0}</span>
        </div>
      </div>
    </div>
  );
}

export default DistrictMap;
